export default __webpack_public_path__ + "assets/images/1b2f9a635e794102bb753cb480b7e522.png";